<div class="modal fade" id="safetyVehicleModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div class="modal-content svm" dir="rtl" *ngIf="vehicle">
            <button class="svm-close" (click)="close()"><i class="fa fa-times"></i></button>

            <div class="svm-header">
                <div class="gauge-container">
                    <canvas id="safetyGaugeCanvas"></canvas>
                    <div class="gauge-value" [style.color]="getStatus(vehicle.SafetyIndex).color">{{ vehicle.SafetyIndex?.toFixed(1) }}</div>
                </div>
                <div class="svm-info">
                    <h2 style="direction:rtl;text-align:right;font-family:inherit;">{{ vehicleName(vehicle) }}</h2>
                    <span class="status-badge" [ngStyle]="{background: getStatus(vehicle.SafetyIndex).bg, color: getStatus(vehicle.SafetyIndex).color, border: '1px solid ' + getStatus(vehicle.SafetyIndex).color + '33'}">{{ getStatus(vehicle.SafetyIndex).label }}</span>
                    <div class="detail-grid">
                        <span class="label">پلاک:</span><span class="value">{{ vehicle.strVehicleNo || '—' }}</span>
                        <span class="label">زمان شروع:</span><span class="value">{{ formatDate(vehicle.dtSDateTime) }}</span>
                        <span class="label">زمان پایان:</span><span class="value">{{ formatDate(vehicle.dtEDateTime) }}</span>
                        <span class="label">شاخص ایمنی:</span><span class="value" [style.color]="getStatus(vehicle.SafetyIndex).color" style="font-weight:700;">{{ vehicle.SafetyIndex?.toFixed(1) }}</span>
                    </div>
                </div>
            </div>

            <div class="score-cards">
                <div class="score-card" *ngFor="let s of scoreCards">
                    <div class="label">{{ s.label }}</div>
                    <div class="value" [style.color]="s.color">
                        <ng-container *ngIf="s.value !== null && s.value !== undefined; else noData">{{ s.value }}</ng-container>
                    </div>
                    <div class="progress-bar-bg">
                        <div class="progress-bar-fill" [style.width.%]="s.percent" [style.background]="s.color"></div>
                    </div>
                </div>
            </div>

            <div class="svm-chart-row">
                <div class="svm-chart-box">
                    <h4><i class="fa fa-bar-chart"></i> مؤلفه‌های ایمنی</h4>
                    <div class="svm-chart-wrapper">
                        <canvas id="safetyModalRadar"></canvas>
                    </div>
                </div>
                <div class="svm-chart-box">
                    <h4><i class="fa fa-list"></i> اطلاعات رانندگی</h4>
                    <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px 16px;font-size:0.8rem;color:#b0c2d4;margin-top:8px;">
                        <span>حداکثر سرعت:</span><span style="color:#e0e9f2;font-weight:500;"><ng-container *ngIf="vehicle.MaxSpeed !== null && vehicle.MaxSpeed !== undefined; else noData">{{ vehicle.MaxSpeed }} km/h</ng-container></span>
                        <span>تعداد کل رویدادهای پرخطر:</span><span style="color:#e0e9f2;font-weight:500;">{{ toFa(vehicle.TotalRiskEvents) }}</span>
                        <span>تعداد رویدادهای پرخطر:</span><span style="color:#e0e9f2;font-weight:500;">{{ toFa(vehicle.TotalHighEvents) }}</span>
                        <span>تعداد رویدادهای بسیار پرخطر:</span><span style="color:#e0e9f2;font-weight:500;">{{ toFa(vehicle.TotalVeryHighEvents) }}</span>
                        <span>رویدادهای شتاب‌گیری:</span><span style="color:#e0e9f2;font-weight:500;">{{ toFa(vehicle.AcceleratorEvents) }}</span>
                        <span>رویدادهای گشتاور:</span><span style="color:#e0e9f2;font-weight:500;">{{ toFa(vehicle.TorqueEvents) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #noData><span class="null-value">بدون داده</span></ng-template>
